// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/entry_point.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum tracker.v1.EntrySelectorKind
 */
export enum EntrySelectorKind {
  /**
   * @generated from enum value: ENTRY_SELECTOR_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A query parameter's NAME is the token: ?<token>, ?<token>=, ?<token>=x.
   * Only the entry point's tokens count — fbclid & co never collide.
   *
   * @generated from enum value: ENTRY_SELECTOR_KIND_QUERY_KEY = 1;
   */
  QUERY_KEY = 1,

  /**
   * The value of the parameter `param`: ?c=<token>.
   *
   * @generated from enum value: ENTRY_SELECTOR_KIND_QUERY_VALUE = 2;
   */
  QUERY_VALUE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(EntrySelectorKind)
proto3.util.setEnumType(EntrySelectorKind, "tracker.v1.EntrySelectorKind", [
  { no: 0, name: "ENTRY_SELECTOR_KIND_UNSPECIFIED" },
  { no: 1, name: "ENTRY_SELECTOR_KIND_QUERY_KEY" },
  { no: 2, name: "ENTRY_SELECTOR_KIND_QUERY_VALUE" },
]);

/**
 * @generated from enum tracker.v1.EntryFallbackKind
 */
export enum EntryFallbackKind {
  /**
   * @generated from enum value: ENTRY_FALLBACK_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The domain's own site (an overlay domain's origin); else 404.
   *
   * @generated from enum value: ENTRY_FALLBACK_KIND_ORIGIN = 1;
   */
  ORIGIN = 1,

  /**
   * @generated from enum value: ENTRY_FALLBACK_KIND_NOT_FOUND = 2;
   */
  NOT_FOUND = 2,

  /**
   * 302 to url.
   *
   * @generated from enum value: ENTRY_FALLBACK_KIND_REDIRECT = 3;
   */
  REDIRECT = 3,

  /**
   * The campaign campaign_id (a white page, a catch-all).
   *
   * @generated from enum value: ENTRY_FALLBACK_KIND_CAMPAIGN = 4;
   */
  CAMPAIGN = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(EntryFallbackKind)
proto3.util.setEnumType(EntryFallbackKind, "tracker.v1.EntryFallbackKind", [
  { no: 0, name: "ENTRY_FALLBACK_KIND_UNSPECIFIED" },
  { no: 1, name: "ENTRY_FALLBACK_KIND_ORIGIN" },
  { no: 2, name: "ENTRY_FALLBACK_KIND_NOT_FOUND" },
  { no: 3, name: "ENTRY_FALLBACK_KIND_REDIRECT" },
  { no: 4, name: "ENTRY_FALLBACK_KIND_CAMPAIGN" },
]);

/**
 * One place the token is read; the first that yields a known token wins.
 *
 * @generated from message tracker.v1.EntrySelector
 */
export class EntrySelector extends Message<EntrySelector> {
  /**
   * @generated from field: tracker.v1.EntrySelectorKind kind = 1;
   */
  kind = EntrySelectorKind.UNSPECIFIED;

  /**
   * QUERY_VALUE: the parameter's name.
   *
   * @generated from field: string param = 2;
   */
  param = "";

  constructor(data?: PartialMessage<EntrySelector>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.EntrySelector";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(EntrySelectorKind) },
    { no: 2, name: "param", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EntrySelector {
    return new EntrySelector().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EntrySelector {
    return new EntrySelector().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EntrySelector {
    return new EntrySelector().fromJsonString(jsonString, options);
  }

  static equals(a: EntrySelector | PlainMessage<EntrySelector> | undefined, b: EntrySelector | PlainMessage<EntrySelector> | undefined): boolean {
    return proto3.util.equals(EntrySelector, a, b);
  }
}

/**
 * A visit without a known token that holds the field condition goes to the
 * campaign.
 *
 * @generated from message tracker.v1.EntryRule
 */
export class EntryRule extends Message<EntryRule> {
  /**
   * A field of the visit (FieldMatch: country, device_type, isp, ip,
   * referrer, param:<name>, …), the op and its values.
   *
   * @generated from field: string field = 1;
   */
  field = "";

  /**
   * @generated from field: string op = 2;
   */
  op = "";

  /**
   * @generated from field: repeated string values = 3;
   */
  values: string[] = [];

  /**
   * @generated from field: string campaign_id = 4;
   */
  campaignId = "";

  constructor(data?: PartialMessage<EntryRule>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.EntryRule";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "op", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EntryRule {
    return new EntryRule().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EntryRule {
    return new EntryRule().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EntryRule {
    return new EntryRule().fromJsonString(jsonString, options);
  }

  static equals(a: EntryRule | PlainMessage<EntryRule> | undefined, b: EntryRule | PlainMessage<EntryRule> | undefined): boolean {
    return proto3.util.equals(EntryRule, a, b);
  }
}

/**
 * @generated from message tracker.v1.EntryFallback
 */
export class EntryFallback extends Message<EntryFallback> {
  /**
   * @generated from field: tracker.v1.EntryFallbackKind kind = 1;
   */
  kind = EntryFallbackKind.UNSPECIFIED;

  /**
   * @generated from field: string url = 2;
   */
  url = "";

  /**
   * @generated from field: string campaign_id = 3;
   */
  campaignId = "";

  constructor(data?: PartialMessage<EntryFallback>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.EntryFallback";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(EntryFallbackKind) },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EntryFallback {
    return new EntryFallback().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EntryFallback {
    return new EntryFallback().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EntryFallback {
    return new EntryFallback().fromJsonString(jsonString, options);
  }

  static equals(a: EntryFallback | PlainMessage<EntryFallback> | undefined, b: EntryFallback | PlainMessage<EntryFallback> | undefined): boolean {
    return proto3.util.equals(EntryFallback, a, b);
  }
}

/**
 * A campaign behind an entry point.
 *
 * @generated from message tracker.v1.CampaignEntry
 */
export class CampaignEntry extends Message<CampaignEntry> {
  /**
   * @generated from field: string entry_point_id = 1;
   */
  entryPointId = "";

  /**
   * @generated from field: string campaign_id = 2;
   */
  campaignId = "";

  /**
   * @generated from field: string token = 3;
   */
  token = "";

  /**
   * The ad link: the entry point's domain, path and first selector.
   *
   * @generated from field: string url = 4;
   */
  url = "";

  /**
   * @generated from field: string campaign_name = 5;
   */
  campaignName = "";

  /**
   * @generated from field: string campaign_status = 6;
   */
  campaignStatus = "";

  /**
   * @generated from field: string entry_point_name = 7;
   */
  entryPointName = "";

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt = "";

  constructor(data?: PartialMessage<CampaignEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entry_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "campaign_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "campaign_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "entry_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignEntry {
    return new CampaignEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignEntry {
    return new CampaignEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignEntry {
    return new CampaignEntry().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignEntry | PlainMessage<CampaignEntry> | undefined, b: CampaignEntry | PlainMessage<CampaignEntry> | undefined): boolean {
    return proto3.util.equals(CampaignEntry, a, b);
  }
}

/**
 * @generated from message tracker.v1.EntryPoint
 */
export class EntryPoint extends Message<EntryPoint> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string tracking_domain_id = 2;
   */
  trackingDomainId = "";

  /**
   * @generated from field: string tracking_domain = 3;
   */
  trackingDomain = "";

  /**
   * @generated from field: string name = 4;
   */
  name = "";

  /**
   * "/" or "/<slug>".
   *
   * @generated from field: string path = 5;
   */
  path = "";

  /**
   * @generated from field: repeated tracker.v1.EntrySelector selectors = 6;
   */
  selectors: EntrySelector[] = [];

  /**
   * @generated from field: repeated tracker.v1.EntryRule rules = 7;
   */
  rules: EntryRule[] = [];

  /**
   * > 0: a signed cookie brings the visitor back to the same campaign.
   *
   * @generated from field: int32 sticky_seconds = 8;
   */
  stickySeconds = 0;

  /**
   * @generated from field: tracker.v1.EntryFallback fallback = 9;
   */
  fallback?: EntryFallback;

  /**
   * ACTIVE | PAUSED (a paused entry point hands its path back).
   *
   * @generated from field: string status = 10;
   */
  status = "";

  /**
   * @generated from field: repeated tracker.v1.CampaignEntry campaigns = 11;
   */
  campaigns: CampaignEntry[] = [];

  /**
   * @generated from field: string owner_id = 12;
   */
  ownerId = "";

  /**
   * @generated from field: string created_at = 13;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 14;
   */
  updatedAt = "";

  constructor(data?: PartialMessage<EntryPoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.EntryPoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tracking_domain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tracking_domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "selectors", kind: "message", T: EntrySelector, repeated: true },
    { no: 7, name: "rules", kind: "message", T: EntryRule, repeated: true },
    { no: 8, name: "sticky_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "fallback", kind: "message", T: EntryFallback },
    { no: 10, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "campaigns", kind: "message", T: CampaignEntry, repeated: true },
    { no: 12, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EntryPoint {
    return new EntryPoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EntryPoint {
    return new EntryPoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EntryPoint {
    return new EntryPoint().fromJsonString(jsonString, options);
  }

  static equals(a: EntryPoint | PlainMessage<EntryPoint> | undefined, b: EntryPoint | PlainMessage<EntryPoint> | undefined): boolean {
    return proto3.util.equals(EntryPoint, a, b);
  }
}

/**
 * The editable part of an entry point.
 *
 * @generated from message tracker.v1.EntryPointInput
 */
export class EntryPointInput extends Message<EntryPointInput> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * @generated from field: repeated tracker.v1.EntrySelector selectors = 3;
   */
  selectors: EntrySelector[] = [];

  /**
   * @generated from field: repeated tracker.v1.EntryRule rules = 4;
   */
  rules: EntryRule[] = [];

  /**
   * @generated from field: int32 sticky_seconds = 5;
   */
  stickySeconds = 0;

  /**
   * @generated from field: tracker.v1.EntryFallback fallback = 6;
   */
  fallback?: EntryFallback;

  /**
   * ACTIVE | PAUSED; empty = ACTIVE.
   *
   * @generated from field: string status = 7;
   */
  status = "";

  constructor(data?: PartialMessage<EntryPointInput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.EntryPointInput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "selectors", kind: "message", T: EntrySelector, repeated: true },
    { no: 4, name: "rules", kind: "message", T: EntryRule, repeated: true },
    { no: 5, name: "sticky_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "fallback", kind: "message", T: EntryFallback },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EntryPointInput {
    return new EntryPointInput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EntryPointInput {
    return new EntryPointInput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EntryPointInput {
    return new EntryPointInput().fromJsonString(jsonString, options);
  }

  static equals(a: EntryPointInput | PlainMessage<EntryPointInput> | undefined, b: EntryPointInput | PlainMessage<EntryPointInput> | undefined): boolean {
    return proto3.util.equals(EntryPointInput, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListEntryPointsRequest
 */
export class ListEntryPointsRequest extends Message<ListEntryPointsRequest> {
  /**
   * Narrows to one domain's entry points.
   *
   * @generated from field: string tracking_domain_id = 1;
   */
  trackingDomainId = "";

  constructor(data?: PartialMessage<ListEntryPointsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListEntryPointsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tracking_domain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEntryPointsRequest {
    return new ListEntryPointsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEntryPointsRequest {
    return new ListEntryPointsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEntryPointsRequest {
    return new ListEntryPointsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListEntryPointsRequest | PlainMessage<ListEntryPointsRequest> | undefined, b: ListEntryPointsRequest | PlainMessage<ListEntryPointsRequest> | undefined): boolean {
    return proto3.util.equals(ListEntryPointsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListEntryPointsResponse
 */
export class ListEntryPointsResponse extends Message<ListEntryPointsResponse> {
  /**
   * @generated from field: repeated tracker.v1.EntryPoint items = 1;
   */
  items: EntryPoint[] = [];

  constructor(data?: PartialMessage<ListEntryPointsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListEntryPointsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: EntryPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEntryPointsResponse {
    return new ListEntryPointsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEntryPointsResponse {
    return new ListEntryPointsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEntryPointsResponse {
    return new ListEntryPointsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListEntryPointsResponse | PlainMessage<ListEntryPointsResponse> | undefined, b: ListEntryPointsResponse | PlainMessage<ListEntryPointsResponse> | undefined): boolean {
    return proto3.util.equals(ListEntryPointsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetEntryPointRequest
 */
export class GetEntryPointRequest extends Message<GetEntryPointRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetEntryPointRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetEntryPointRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEntryPointRequest {
    return new GetEntryPointRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEntryPointRequest {
    return new GetEntryPointRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEntryPointRequest {
    return new GetEntryPointRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetEntryPointRequest | PlainMessage<GetEntryPointRequest> | undefined, b: GetEntryPointRequest | PlainMessage<GetEntryPointRequest> | undefined): boolean {
    return proto3.util.equals(GetEntryPointRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetEntryPointResponse
 */
export class GetEntryPointResponse extends Message<GetEntryPointResponse> {
  /**
   * @generated from field: tracker.v1.EntryPoint entry_point = 1;
   */
  entryPoint?: EntryPoint;

  constructor(data?: PartialMessage<GetEntryPointResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetEntryPointResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entry_point", kind: "message", T: EntryPoint },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEntryPointResponse {
    return new GetEntryPointResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEntryPointResponse {
    return new GetEntryPointResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEntryPointResponse {
    return new GetEntryPointResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetEntryPointResponse | PlainMessage<GetEntryPointResponse> | undefined, b: GetEntryPointResponse | PlainMessage<GetEntryPointResponse> | undefined): boolean {
    return proto3.util.equals(GetEntryPointResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateEntryPointRequest
 */
export class CreateEntryPointRequest extends Message<CreateEntryPointRequest> {
  /**
   * @generated from field: string tracking_domain_id = 1;
   */
  trackingDomainId = "";

  /**
   * @generated from field: tracker.v1.EntryPointInput input = 2;
   */
  input?: EntryPointInput;

  constructor(data?: PartialMessage<CreateEntryPointRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateEntryPointRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tracking_domain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "input", kind: "message", T: EntryPointInput },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateEntryPointRequest {
    return new CreateEntryPointRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateEntryPointRequest {
    return new CreateEntryPointRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateEntryPointRequest {
    return new CreateEntryPointRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateEntryPointRequest | PlainMessage<CreateEntryPointRequest> | undefined, b: CreateEntryPointRequest | PlainMessage<CreateEntryPointRequest> | undefined): boolean {
    return proto3.util.equals(CreateEntryPointRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateEntryPointResponse
 */
export class CreateEntryPointResponse extends Message<CreateEntryPointResponse> {
  /**
   * @generated from field: tracker.v1.EntryPoint entry_point = 1;
   */
  entryPoint?: EntryPoint;

  constructor(data?: PartialMessage<CreateEntryPointResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateEntryPointResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entry_point", kind: "message", T: EntryPoint },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateEntryPointResponse {
    return new CreateEntryPointResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateEntryPointResponse {
    return new CreateEntryPointResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateEntryPointResponse {
    return new CreateEntryPointResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateEntryPointResponse | PlainMessage<CreateEntryPointResponse> | undefined, b: CreateEntryPointResponse | PlainMessage<CreateEntryPointResponse> | undefined): boolean {
    return proto3.util.equals(CreateEntryPointResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateEntryPointRequest
 */
export class UpdateEntryPointRequest extends Message<UpdateEntryPointRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: tracker.v1.EntryPointInput input = 2;
   */
  input?: EntryPointInput;

  constructor(data?: PartialMessage<UpdateEntryPointRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateEntryPointRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "input", kind: "message", T: EntryPointInput },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateEntryPointRequest {
    return new UpdateEntryPointRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateEntryPointRequest {
    return new UpdateEntryPointRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateEntryPointRequest {
    return new UpdateEntryPointRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateEntryPointRequest | PlainMessage<UpdateEntryPointRequest> | undefined, b: UpdateEntryPointRequest | PlainMessage<UpdateEntryPointRequest> | undefined): boolean {
    return proto3.util.equals(UpdateEntryPointRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateEntryPointResponse
 */
export class UpdateEntryPointResponse extends Message<UpdateEntryPointResponse> {
  /**
   * @generated from field: tracker.v1.EntryPoint entry_point = 1;
   */
  entryPoint?: EntryPoint;

  constructor(data?: PartialMessage<UpdateEntryPointResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateEntryPointResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entry_point", kind: "message", T: EntryPoint },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateEntryPointResponse {
    return new UpdateEntryPointResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateEntryPointResponse {
    return new UpdateEntryPointResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateEntryPointResponse {
    return new UpdateEntryPointResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateEntryPointResponse | PlainMessage<UpdateEntryPointResponse> | undefined, b: UpdateEntryPointResponse | PlainMessage<UpdateEntryPointResponse> | undefined): boolean {
    return proto3.util.equals(UpdateEntryPointResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveEntryPointRequest
 */
export class ArchiveEntryPointRequest extends Message<ArchiveEntryPointRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ArchiveEntryPointRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveEntryPointRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveEntryPointRequest {
    return new ArchiveEntryPointRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveEntryPointRequest {
    return new ArchiveEntryPointRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveEntryPointRequest {
    return new ArchiveEntryPointRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveEntryPointRequest | PlainMessage<ArchiveEntryPointRequest> | undefined, b: ArchiveEntryPointRequest | PlainMessage<ArchiveEntryPointRequest> | undefined): boolean {
    return proto3.util.equals(ArchiveEntryPointRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveEntryPointResponse
 */
export class ArchiveEntryPointResponse extends Message<ArchiveEntryPointResponse> {
  constructor(data?: PartialMessage<ArchiveEntryPointResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveEntryPointResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveEntryPointResponse {
    return new ArchiveEntryPointResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveEntryPointResponse {
    return new ArchiveEntryPointResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveEntryPointResponse {
    return new ArchiveEntryPointResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveEntryPointResponse | PlainMessage<ArchiveEntryPointResponse> | undefined, b: ArchiveEntryPointResponse | PlainMessage<ArchiveEntryPointResponse> | undefined): boolean {
    return proto3.util.equals(ArchiveEntryPointResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.BindCampaignRequest
 */
export class BindCampaignRequest extends Message<BindCampaignRequest> {
  /**
   * @generated from field: string entry_point_id = 1;
   */
  entryPointId = "";

  /**
   * @generated from field: string campaign_id = 2;
   */
  campaignId = "";

  /**
   * Letters, digits, _ . - (up to 100); empty = a new random UUID.
   *
   * @generated from field: string token = 3;
   */
  token = "";

  constructor(data?: PartialMessage<BindCampaignRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.BindCampaignRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entry_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BindCampaignRequest {
    return new BindCampaignRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BindCampaignRequest {
    return new BindCampaignRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BindCampaignRequest {
    return new BindCampaignRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BindCampaignRequest | PlainMessage<BindCampaignRequest> | undefined, b: BindCampaignRequest | PlainMessage<BindCampaignRequest> | undefined): boolean {
    return proto3.util.equals(BindCampaignRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.BindCampaignResponse
 */
export class BindCampaignResponse extends Message<BindCampaignResponse> {
  /**
   * @generated from field: tracker.v1.CampaignEntry entry = 1;
   */
  entry?: CampaignEntry;

  constructor(data?: PartialMessage<BindCampaignResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.BindCampaignResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entry", kind: "message", T: CampaignEntry },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BindCampaignResponse {
    return new BindCampaignResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BindCampaignResponse {
    return new BindCampaignResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BindCampaignResponse {
    return new BindCampaignResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BindCampaignResponse | PlainMessage<BindCampaignResponse> | undefined, b: BindCampaignResponse | PlainMessage<BindCampaignResponse> | undefined): boolean {
    return proto3.util.equals(BindCampaignResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UnbindCampaignRequest
 */
export class UnbindCampaignRequest extends Message<UnbindCampaignRequest> {
  /**
   * @generated from field: string entry_point_id = 1;
   */
  entryPointId = "";

  /**
   * @generated from field: string campaign_id = 2;
   */
  campaignId = "";

  constructor(data?: PartialMessage<UnbindCampaignRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UnbindCampaignRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entry_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnbindCampaignRequest {
    return new UnbindCampaignRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnbindCampaignRequest {
    return new UnbindCampaignRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnbindCampaignRequest {
    return new UnbindCampaignRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UnbindCampaignRequest | PlainMessage<UnbindCampaignRequest> | undefined, b: UnbindCampaignRequest | PlainMessage<UnbindCampaignRequest> | undefined): boolean {
    return proto3.util.equals(UnbindCampaignRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UnbindCampaignResponse
 */
export class UnbindCampaignResponse extends Message<UnbindCampaignResponse> {
  constructor(data?: PartialMessage<UnbindCampaignResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UnbindCampaignResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnbindCampaignResponse {
    return new UnbindCampaignResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnbindCampaignResponse {
    return new UnbindCampaignResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnbindCampaignResponse {
    return new UnbindCampaignResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UnbindCampaignResponse | PlainMessage<UnbindCampaignResponse> | undefined, b: UnbindCampaignResponse | PlainMessage<UnbindCampaignResponse> | undefined): boolean {
    return proto3.util.equals(UnbindCampaignResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCampaignEntriesRequest
 */
export class ListCampaignEntriesRequest extends Message<ListCampaignEntriesRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  constructor(data?: PartialMessage<ListCampaignEntriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCampaignEntriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCampaignEntriesRequest {
    return new ListCampaignEntriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCampaignEntriesRequest {
    return new ListCampaignEntriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCampaignEntriesRequest {
    return new ListCampaignEntriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCampaignEntriesRequest | PlainMessage<ListCampaignEntriesRequest> | undefined, b: ListCampaignEntriesRequest | PlainMessage<ListCampaignEntriesRequest> | undefined): boolean {
    return proto3.util.equals(ListCampaignEntriesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCampaignEntriesResponse
 */
export class ListCampaignEntriesResponse extends Message<ListCampaignEntriesResponse> {
  /**
   * @generated from field: repeated tracker.v1.CampaignEntry items = 1;
   */
  items: CampaignEntry[] = [];

  constructor(data?: PartialMessage<ListCampaignEntriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCampaignEntriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: CampaignEntry, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCampaignEntriesResponse {
    return new ListCampaignEntriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCampaignEntriesResponse {
    return new ListCampaignEntriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCampaignEntriesResponse {
    return new ListCampaignEntriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCampaignEntriesResponse | PlainMessage<ListCampaignEntriesResponse> | undefined, b: ListCampaignEntriesResponse | PlainMessage<ListCampaignEntriesResponse> | undefined): boolean {
    return proto3.util.equals(ListCampaignEntriesResponse, a, b);
  }
}

